import { SHAPE_STROKE_PROPS } from './stroke-props';

interface TriangleProps {
  strokeDasharray: string | undefined;
}

export default function Triangle({ strokeDasharray }: TriangleProps) {
  return (
    <polygon
      points="50,0 100,100 0,100"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
